export default "__VITE_ASSET__D16_C1cZ__"